import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { QualityDocumentGroupFormComponent } from '../../../components/quality-document-group-form/quality-document-group-form.component';
import { QualityManagementService } from '../../../../../services/quality-management.service';
import { RouteService } from '../../../../../services/route.service';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';

@Component({
  selector: 'app-quality-document-group-edit-page',
  imports: [QualityDocumentGroupFormComponent],
  templateUrl: './quality-document-group-edit-page.component.html',
  styleUrl: './quality-document-group-edit-page.component.scss'
})
export class QualityDocumentGroupEditPageComponent implements OnInit {

  companyDocumentGroupId?: number;
  companyDocumentGroup?: any;

  constructor(
    private route: ActivatedRoute,
    private qualityManagementService: QualityManagementService,
    private routeService: RouteService,
    private alertNotificationService: AlertNotificationService
  ) { }

  ngOnInit(): void {
    const paramId = this.route.snapshot.paramMap.get('companyDocumentGroupId');

    if (paramId) {
      this.companyDocumentGroupId = Number(paramId);
      this.loadData(this.companyDocumentGroupId);
    }
  }

  get pageTitle(): string {
    return this.companyDocumentGroupId ? 'Update Quality Document Group' : 'Create Quality Document Group';
  }

  onSavedData(savedData: SavedDataInfo): void {
    if (!savedData.success || this.companyDocumentGroupId) {
      return;
    }

    const created = this.qualityManagementService
      .readResponseKey(savedData.response, 'companyDocumentGroup');

    if (created?.companyDocumentGroupId) {
      this.routeService.qualityDocumentGroupDetail(Number(created.companyDocumentGroupId));
    } else {
      this.routeService.qualityDocumentGroupIndex();
    }
  }

  private loadData(companyDocumentGroupId: number): void {
    this.qualityManagementService.detailCompanyDocumentGroup(companyDocumentGroupId).subscribe({
      next: (response: any) => {
        this.companyDocumentGroup = this.qualityManagementService
          .readResponseKey(response, 'companyDocumentGroup');
      },
      error: (error: any) => {
        console.error('Error loading the company document group:', error);
        this.alertNotificationService.error(
          this.qualityManagementService.companyDocumentErrorMessage(
            error,
            'Failed to load the company document group.'
          )
        );
      }
    });
  }
}
